import React from 'react'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { ActionButton } from '@emerald-works-nova/components'
import { Box, Typography } from '@mui/material'
import { BannerStatic } from '../../../../components'

const PasswordReset = ({ user, userPoolId }) => {
  const [resetPassword] = useEvent([
    {
      eventName: 'adminTriggerPasswordReset',
      onSuccess: () => {
        BannerStatic.show({
          label: 'Password reset email has been sent to the user'
        })
      },
      onError: e => {
        console.error('adminTriggerPasswordReset ', e)
        BannerStatic.show({ label: e.message, isError: true, autoHide: false })
      }
    }
  ])

  const handlePasswordResetEmail = async () => {
    resetPassword.trigger({
      username: user.username,
      userPoolId
    })
  }

  return (
    <Box display='flex' flexDirection='column' alignItems='flex-start'>
      <Typography variant='h5' gutterBottom data-test='password-reset'>
          Password Reset
      </Typography>
      <Typography
        variant='caption'
        color='GrayText'
        style={{ fontSize: 13 }}
      >
          Send to users the email with instructions to reset their password.
      </Typography>
      <ActionButton
        style={{ marginTop: 20 }}
        onClick={handlePasswordResetEmail}
        variant='secondary'
        isWorking={resetPassword.isWorking}
        disabled={resetPassword.isWorking}
        dataTest='password-reset-send-email-button'
      >
              Send email
      </ActionButton>
    </Box>
  )
}

export default PasswordReset
